import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const s = {
  page: { minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '2rem', gap: '1.5rem' },
  header: { display: 'flex', alignItems: 'center', gap: '1rem', width: '100%', maxWidth: '600px' },
  back: { background: 'rgba(255,255,255,0.1)', color: 'white', borderRadius: '12px', padding: '0.5rem 1rem', fontSize: '1.2rem', border: 'none', cursor: 'pointer' },
  xpRow: { display: 'flex', gap: '1rem', fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: 700 },
  card: { background: 'rgba(255,255,255,0.05)', border: '2px solid rgba(255,255,255,0.1)', borderRadius: '24px', padding: '2.5rem', width: '100%', maxWidth: '600px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2rem' },
  hearBtn: { background: 'rgba(243,114,44,0.2)', border: '2px solid #f3722c', color: '#f3722c', borderRadius: '14px', padding: '0.8rem 1.5rem', fontSize: '1rem', fontWeight: 800 },
  hearSentBtn: { background: 'rgba(76,201,240,0.1)', border: '2px solid var(--blue)', color: 'var(--blue)', borderRadius: '14px', padding: '0.8rem 1.5rem', fontSize: '1rem', fontWeight: 800 },
  input: { background: 'rgba(255,255,255,0.1)', border: '3px solid rgba(255,255,255,0.2)', borderRadius: '16px', padding: '1rem 1.5rem', fontSize: '1.8rem', color: 'white', textAlign: 'center', width: '100%', maxWidth: '300px', outline: 'none', letterSpacing: '2px' },
  checkBtn: { background: '#f3722c', color: 'white', borderRadius: '16px', padding: '1rem 2.5rem', fontSize: '1.2rem', fontWeight: 900, border: 'none', cursor: 'pointer' },
  nextBtn: { background: 'var(--green)', color: 'white', borderRadius: '16px', padding: '1rem 2.5rem', fontSize: '1.2rem', fontWeight: 900, border: 'none', cursor: 'pointer' },
  xpFloat: { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', fontSize: '3rem', fontFamily: 'Bangers, cursive', color: '#f3722c', pointerEvents: 'none', animation: 'xpPop 1s ease forwards', zIndex: 9999 },
};

function speak(text) {
  return new Promise((resolve) => {
    if (!window.speechSynthesis) return resolve();
    window.speechSynthesis.cancel();
    const utt = new SpeechSynthesisUtterance(text);
    utt.lang = 'da-DK';
    utt.rate = 0.85;
    utt.onend = resolve;
    window.speechSynthesis.speak(utt);
  });
}

export default function Dansk({ user, name, age }) {
  const navigate = useNavigate();
  const [wordData, setWordData] = useState(null);
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState(null);
  const [xp, setXp] = useState({ today: 0, week: 0, year: 0 });
  const [loading, setLoading] = useState(true);
  const [speaking, setSpeaking] = useState(false);
  const [showXpFloat, setShowXpFloat] = useState(false);
  const [xpGained, setXpGained] = useState(0);

  useEffect(() => {
    fetch('/api/xp/'+user).then(r => r.json()).then(d => setXp(d.dansk || { today: 0, week: 0, year: 0 })).catch(() => {});
    loadWord();
  }, [user]);

  const loadWord = async () => {
    setLoading(true);
    setFeedback(null);
    setAnswer('');
    try {
      const r = await fetch('/api/dansk/word?age='+age);
      setWordData(await r.json());
    } catch (e) {
      setWordData({ word: 'skole', sentence: 'Jeg går i skole hver dag.' });
    }
    setLoading(false);
  };

  const hearWord = async () => {
    if (!wordData || speaking) return;
    setSpeaking(true);
    await speak(wordData.word);
    setSpeaking(false);
  };

  const hearSentence = async () => {
    if (!wordData || speaking) return;
    setSpeaking(true);
    await speak(wordData.sentence);
    setSpeaking(false);
  };

  const addXP = async (pts) => {
    await fetch('/api/xp', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ user, subject: 'dansk', points: pts }) });
    setXp(prev => ({ today: prev.today+pts, week: prev.week+pts, year: prev.year+pts }));
    setXpGained(pts);
    setShowXpFloat(true);
    setTimeout(() => setShowXpFloat(false), 1000);
  };

  const check = async () => {
    if (!wordData || !answer.trim()) return;
    if (answer.trim().toLowerCase() === wordData.word.toLowerCase()) {
      setFeedback('correct');
      await addXP(3);
    } else {
      setFeedback('wrong');
    }
  };

  return (
    <div style={s.page}>
      {showXpFloat && <div style={s.xpFloat}>+{xpGained} XP</div>}
      <div style={s.header}>
        <button style={s.back} onClick={() => navigate('/'+user)}>tilbage</button>
        <h1 style={{ fontFamily: 'Bangers, cursive', fontSize: '2rem', letterSpacing: '3px', color: '#f3722c', flex: 1 }}>Dansk Diktat</h1>
      </div>
      <div style={s.xpRow}>
        <span>I dag: <strong style={{ color: '#f3722c' }}>{xp.today} XP</strong></span>
        <span>Uge: <strong style={{ color: '#f3722c' }}>{xp.week} XP</strong></span>
        <span>År: <strong style={{ color: '#f3722c' }}>{xp.year} XP</strong></span>
      </div>
      <div style={s.card}>
        {loading ? (
          <div style={{ color: 'var(--text-muted)' }}>Henter ord...</div>
        ) : (
          <>
            <div style={{ fontSize: '5rem' }}>🎧</div>
            <div style={{ color: 'var(--text-muted)', fontWeight: 700, textAlign: 'center' }}>Tryk på knappen for at høre ordet, og skriv det bagefter</div>
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
              <button style={{ ...s.hearBtn, opacity: speaking ? 0.6 : 1 }} onClick={hearWord} disabled={speaking}>Hør ordet</button>
              <button style={{ ...s.hearSentBtn, opacity: speaking ? 0.6 : 1 }} onClick={hearSentence} disabled={speaking}>Hør sætning</button>
            </div>
            {feedback === null && (
              <>
                <input style={s.input} type="text" value={answer} onChange={e => setAnswer(e.target.value)} onKeyDown={e => e.key === 'Enter' && check()} placeholder="Skriv ordet..." autoComplete="off" autoCorrect="off" spellCheck="false" />
                <button style={s.checkBtn} onClick={check}>Tjek</button>
              </>
            )}
            {feedback === 'correct' && (
              <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
                <div style={{ fontSize: '2rem', fontFamily: 'Bangers, cursive', color: 'var(--green)' }}>Rigtigt! +3 XP</div>
                <div style={{ fontFamily: 'Bangers, cursive', fontSize: '3rem', color: 'var(--green)', letterSpacing: '4px' }}>{wordData.word}</div>
                <div style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>"{wordData.sentence}"</div>
                <button style={s.nextBtn} onClick={loadWord}>Næste ord</button>
              </div>
            )}
            {feedback === 'wrong' && (
              <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
                <div style={{ fontSize: '2rem', fontFamily: 'Bangers, cursive', color: 'var(--red)' }}>Det rigtige svar var:</div>
                <div style={{ fontFamily: 'Bangers, cursive', fontSize: '3rem', color: 'var(--green)', letterSpacing: '4px' }}>{wordData.word}</div>
                <div style={{ color: 'var(--text-muted)', fontStyle: 'italic' }}>"{wordData.sentence}"</div>
                <button style={s.nextBtn} onClick={loadWord}>Prøv et nyt ord</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
